import { computed } from 'vue';

export default function useAccount() {
  const navUser = useNavUser();

  const isSignedIn = computed(() => navUser.data.isSignedIn);
  const username = computed(() => navUser.data.username);

  return { isSignedIn, username };
}
